const T=6e4,e=1e4;var o={THROTTLE_TIME:6e4,THROTTLE_INTERVAL:1e4,showCountdownTimer:!1};export{e as THROTTLE_INTERVAL,T as THROTTLE_TIME,o as default};
